import { GET_STATES } from "../types";

const initialState = {
  states: [],
};

const states = (state = initialState, action) => {
  switch (action.type) {
    case GET_STATES:
      return {
        ...state,
        states: action.states,
      };
    default:
      return state;
  }
};

export default states;
